import { create } from "zustand";

import { ADMIN_REFRESH_STORAGE_KEY } from "@/api/constants";
import {
  clearRefreshToken,
  postRefreshToken,
  readRefreshToken,
  writeRefreshToken,
} from "@/api/refreshToken";

/** access_token 仅驻内存；refresh_token 仅 sessionStorage（禁止 localStorage） */
export const useAuthStore = create<{
  accessToken: string | null;
  bootstrapped: boolean;
  setAccessToken: (t: string | null) => void;
  setSessionFromLogin: (access: string, refresh: string) => void;
  clearSession: () => void;
  bootstrapFromRefresh: () => Promise<boolean>;
}>()((set) => ({
  accessToken: null,
  bootstrapped: false,
  setAccessToken: (t) => set({ accessToken: t }),
  setSessionFromLogin: (access, refresh) => {
    writeRefreshToken(refresh);
    set({ accessToken: access, bootstrapped: true });
  },
  clearSession: () => {
    clearRefreshToken();
    set({ accessToken: null, bootstrapped: true });
  },
  bootstrapFromRefresh: async () => {
    const existing = readRefreshToken();
    if (!existing) {
      set({ bootstrapped: true });
      return false;
    }
    const pair = await postRefreshToken(existing);
    if (!pair) {
      clearRefreshToken();
      set({ accessToken: null, bootstrapped: true });
      return false;
    }
    writeRefreshToken(pair.refresh_token);
    set({ accessToken: pair.access_token, bootstrapped: true });
    return true;
  },
}));

export { ADMIN_REFRESH_STORAGE_KEY };
